import { Component, OnInit } from '@angular/core';
import { BunnyPlayerjsTestComponent } from '../bunny-playerjs-test/bunny-playerjs-test.component';
import { DwComponent, DwComponentType } from '@devwareapps/devware-cap';

// @DwComponent({
//   name: 'Bunny PlayerJS Test Component',
//   key: 'bunnyPlayerjsTestComponent',
//   componentType: DwComponentType.pageComponent,
//   isGlobal: true,
// })
@Component({
  selector: 'app-bunny-playerjs-test2',
  templateUrl: './bunny-playerjs-test2.component.html',
  styleUrls: ['./bunny-playerjs-test2.component.scss']
})
export class BunnyPlayerjsTest2Component implements OnInit {
  instance: BunnyPlayerjsTestComponent;
  
  videoComponentType = BunnyPlayerjsTestComponent;

  constructor() { }

  ngOnInit(): void {
  }

  configureVideoComponent(instance: BunnyPlayerjsTestComponent) {
    this.instance = instance;

    this.instance.setupVideo();
  }

}
